import { c as _c } from "react/compiler-runtime";
import ExpandableText from "../ExpandableText";
import { useProductBuilderContext } from "./ProductBuilderContext";
export default function Description() {
  const $ = _c(2);
  const {
    parentProductDescription,
    productWrapper,
    product
  } = useProductBuilderContext();
  const description = parentProductDescription || productWrapper.descriptionOverride || product.description;
  if (!description) {
    return null;
  }
  let t0;
  if ($[0] !== description) {
    t0 = <ExpandableText text={description} />;
    $[0] = description;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}